import { exists } from '@/helpers'
import type { CategoryWithChannels } from '@setplex/tria-api'
import type { TvChannelPayment } from '~/features/payment/interfaces'

enum CustomCategoryName {
  Banner = 'Banner',
  Featured = 'Featured Live Channels',
  All = 'All',
}

export const formatSelectedTvChannel = ({
  selectedChannel,
  categories,
}: {
  selectedChannel: TvChannelPayment
  categories: CategoryWithChannels[] | null
}) => {
  let categoryName = ''

  const selectedCategory = categories?.filter(
    ({ id }) => selectedChannel.categoryId === id
  )[0]

  const selectedCategoryName = selectedCategory?.name

  if (exists(selectedCategoryName)) {
    categoryName = selectedCategoryName
  }

  if (selectedChannel.featured) {
    categoryName = CustomCategoryName.Featured
  }

  if (selectedChannel.isBanner) {
    categoryName = CustomCategoryName.Banner
  }

  if (selectedChannel.isAll) {
    categoryName = CustomCategoryName.All
  }

  return { ...selectedChannel, categoryName }
}
